import {
  SHOW_ERROR_MESSAGE,
  HIDE_ERROR_MESSAGE,
  CLEAR_ERROR_DISPLAY,
  DISMISS_ERROR_MESSAGE,
  DISPLAY_ERROR_MESSAGE,
  HIDE_ERROR_DISPLAY,
  CLEAR_ERROR_DISPLAY_STATE
} from './actions';

const initialState = {
  isVisible: false,
  message: null,
  type: null, // 'network', 'auth', 'warning', 'info'
  context: null,
  timestamp: null,
  duration: 5000,
  isDismissed: false
};

const errorDisplayReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ERROR_MESSAGE:
      return {
        ...state,
        isVisible: true,
        message: action.payload.message,
        type: action.payload.type,
        context: action.payload.context,
        duration: action.payload.duration,
        isDismissed: false,
        timestamp: new Date().toISOString()
      };

    case HIDE_ERROR_MESSAGE:
      return {
        ...state,
        isVisible: false,
        isDismissed: true
      };

    case DISPLAY_ERROR_MESSAGE:
      return {
        ...state,
        isVisible: true,
        message: action.payload.message,
        type: action.payload.type,
        context: action.payload.context,
        timestamp: action.payload.timestamp,
        isDismissed: false
      };

    case HIDE_ERROR_DISPLAY:
      return {
        ...state,
        isVisible: false,
        isDismissed: true
      };

    case DISMISS_ERROR_MESSAGE:
      return {
        ...state,
        isVisible: false,
        isDismissed: true
      };

    case CLEAR_ERROR_DISPLAY:
    case CLEAR_ERROR_DISPLAY_STATE:
      return {
        ...initialState
      };

    default:
      return state;
  }
};

export default errorDisplayReducer;
